__turbopack_context__.v({
  "container": "twoColumnTextImage-module-scss-module__heqZ1q__container",
});
